$(function () {
    if ($("#AcceptEnrolmentForm").length > 0) {

        $(function () {



            $("input[readOnly]").on('click mousedown mouseup touchstart touchend', function (e) {
                if (e.cancelable) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                return false;
            });

            $(".child-radiobutton").on("change", function (e) {
                // e.preventDefault();
                // e.stopPropagation();
                // e.stopImmediatePropagation();

                if ($(this).is(':checked')) {

                    //store this in a global DOB variable
                    jsChildDOB = $(this).data("dob");
                    jsChildId = $(this).data("id");
                    jsNBEN = $(this).data("nben");
                    jsParentId = $("#ParentId").val();

                    //console.log("nben:" + jsNBEN);


                    try {
                        $('.btnConfirm').prop("disabled", true);
                        //Check if the child is part of a waitlist
                        CheckExistingWaitlist(jsChildId, jsParentId);

                        if (jsParentHasBenefits) {
                            LoadCFASection(jsChildId, jsNBEN, false, $("#ParentId").val());
                        } else {
                            $('.btnConfirm').prop("disabled", false);
                        }
                    }
                    catch {
                        $('.btnConfirm').prop("disabled", false);
                    }

                }

            })

            $(".WaitlistFutureSameChild-RadioButton").on("change", function (e) {
                e.preventDefault();
                e.stopPropagation();

                //store this in a global DOB variable
                jsWaitlistFuture = $(this).val();

                if (jsWaitlistFuture == 'true') {
                    //Hide the remain on waitlist questions
                    $("#id_WaitlistRemainOn").removeClass("d-none");
                }
                else {
                    //Hide the remain on waitlist questions
                    $("#id_WaitlistRemainOn").addClass("d-none");
                }

            });

            function ConfigureForm() {

                //Does a waitlist exist?
                if (jsChildNotYetBorn) {
                    $("#WaitlistExists").removeClass("d-none");

                    //Is the child not yet born?
                    $("#id_WaitlistFutureSameChild").removeClass("d-none");
                    $("#id_WaitlistSelectChildLabel").addClass("d-none");

                    //Hide the remain on waitlist questions
                    $("#id_WaitlistRemainOn").addClass("d-none");

                    if (jsWaitlistFuture == 'true') {
                        //Hide the remain on waitlist questions
                        $("#id_WaitlistRemainOn").removeClass("d-none");
                    }
                    else {
                        //Hide the remain on waitlist questions
                        $("#id_WaitlistRemainOn").addClass("d-none");
                    }

                }
                else {
                    $("#WaitlistExists").addClass("d-none");

                    //Does a waitlist exist?
                    if (jsExistingwaitlist) {
                        $("#WaitlistExists").removeClass("d-none");

                        $("#id_WaitlistFutureSameChild").addClass("d-none");
                        $("#id_WaitlistSelectChildLabel").removeClass("d-none");

                        //Show the remain on waitlist questions
                        $("#id_WaitlistRemainOn").removeClass("d-none");
                    }
                }
            };

            //Display the waitlist confirmation controls.
            ConfigureForm();

        });

        //Load CFA section based on child selected
        function LoadCFASection(id, nben, preselect, uid) {
            var url = '';

            

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/financialassistance/home/cfaenrolmentoffer/' + id + "?NBEN=" + nben + "&uid=" + uid + "&confirmationCode=" + jsConfirmationCode;
            } else {
                url = location.href.split('/fr/')[0] + '/fr/financialassistance/home/cfaenrolmentoffer/' + id + "?NBEN=" + nben + "&uid=" + uid + "&confirmationCode=" + jsConfirmationCode;
            }

            var docloads = [];

            docloads.push(
                $.Deferred(function (def) {
                    $("#cfasection").load(url, def.resolve);
                }).promise());

            $.when.apply($, docloads).then(function () { SetupDocButtons(preselect); })

        }

        function SetupDocButtons(ispreselect) {

            var lang = 'en';
            if (window.location.href.includes('/en/')) { lang = 'en' }
            else { lang = 'fr' }

            $('#cfasection .cfaradio').each(function () {
                this.checked = false;
            });

            $('#cfasection .noticegivenradio').each(function () {
                this.checked = false;
            });

            var cd = $("input[name='continue']:checked").val();
            var cfatypeid = $(".cfaapptype").val();
            var childhaspreapporvalchildprgm = $(".childhaspreapporvalchildprgm").val();

            if (jsParentHasChilPrograms && cfatypeid == '3') {
                console.log(cfatypeid);
                $("#cfasection .noSubsidyMsg").removeClass("d-none");
                $("#ParentHasExistingCFA").val('False');
            }

            if (childhaspreapporvalchildprgm) {
                console.log(childhaspreapporvalchildprgm);
                $("#ParentHasExistingCFA").val('True');
            }

            //$('#cfasection .fileuploadradio').each(function () {
            //    this.checked = false;
            //});

            if (ispreselect) {

                $("input[id='fileyes']").prop("checked", true);
                $("#cfasection .fileupload").removeClass("d-none");
                $("#cfasection .doclist").removeClass("d-none");

                $("#cfasection .noSubsidyMsg").addClass("d-none");
                $("#ParentHasExistingCFA").val('True');
            }


            $("#cfasection .cfaradio").on("click", function () {

                var id = $(this).data("id");
                jsDataId = $(this).data("id");

                var cd = $(".cfaradio[data-id=" + id + "]:checked").val();

                if (cd == 'false') {
                    $("#cfasection .stopdate[data-id=" + id + "]").removeClass("d-none");
                    $("#cfasection .noticegivendiv[data-id=" + id + "]").removeClass("d-none");
                }
                else {
                    $("#cfasection .stopdate[data-id=" + id + "]").addClass("d-none");
                    $("#cfasection .noticegivendiv[data-id=" + id + "]").addClass("d-none");
                }

            });

            $("#cfasection .noticegivenradio").on("click", function () {

                var id = $(this).data("id");
                jsDataId = $(this).data("id");

                var cd = $(".noticegivenradio[data-id=" + id + "]:checked").val();

                if (cd == 'true') {
                    $("#cfasection .noticedate[data-id=" + id + "]").removeClass("d-none");
                }
                else {
                    $("#cfasection .noticedate[data-id=" + id + "]").addClass("d-none");
                }

            });

            $("input[name='fileupload']").on("click", function () {

                var cd = $("input[name='fileupload']:checked").val();

                if (jsParentHasChilPrograms) {
                    if (cd == 'true') {
                        $("#cfasection .fileupload").removeClass("d-none");
                        $("#cfasection .doclist").removeClass("d-none");
                        $("#cfasection #ChildHasSpecialCircumstance").val('True');
                        $("#cfasection .noSubsidyMsg").addClass("d-none");
                        $("#ParentHasExistingCFA").val('True');
                    }
                    else {
                        $("#cfasection .fileupload").addClass("d-none");
                        $("#cfasection .doclist").addClass("d-none");
                        $("#cfasection .noSubsidyMsg").removeClass("d-none");
                        $("#ParentHasExistingCFA").val('False');
                    }
                }

            });

            $(document).on('change', "#_uploadDocTypes", function () {
                //var obj = {};
                var cd = $(this).val();
                var lbl;



                if ($(this).val() == '') {
                    $("#_fileUpload .btnUpload").prop('disabled', true).attr('disabled', 'disabled');
                }
                else {
                    $("#_fileUpload .btnUpload").removeProp('disabled').removeAttr('disabled');

                    $("#helpertext-alert").removeClass('d-none');
                    lbl = $("#helpertext-lbl");

                    if (obj[cd] != undefined) {
                        console.log(obj[cd]);
                        lbl.html($('<div />').html(obj[cd]).text());
                    }
                }
            });

            $(".dateobj").click(function () {

                jsDataId = $(this).data("id");
                jsDataType = $(this).data("type");

                $('.dp14').datetimepicker({
                    inline: true,
                    sideBySide: false,
                    viewMode: "days",
                    format: "YYYY-MM-DD",
                    locale: app.currentLanguage() + "-ca",
                    keepOpen: false
                });

                $(".datediv[data-id=" + jsDataId + "]").show();
            });

            $(".noticedateobj").click(function () {

                jsDataId = $(this).data("id");
                jsDataType = $(this).data("type");

                $('.dp13').datetimepicker({
                    inline: true,
                    sideBySide: false,
                    viewMode: "days",
                    format: "YYYY-MM-DD",
                    locale: app.currentLanguage() + "-ca",
                    keepOpen: false,
                    title: "noticedate"
                });

                $(".noticedatediv[data-id=" + jsDataId + "]").show();
            });

            $(document).on('change.datetimepicker', function (e) {

                if (e.date != undefined) {

                    console.log("type:" + jsDataType);

                    var dt = e.date.format('YYYY-MM-DD');

                    if (jsDataType == 'stopdt') {
                        $(".stopdt[data-id=" + jsDataId + "]").val(dt);
                        $(".datediv[data-id=" + jsDataId + "]").hide();
                    }

                    if (jsDataType == 'noticedt') {
                        $(".noticedt[data-id=" + jsDataId + "]").val(dt);
                        $(".noticedatediv[data-id=" + jsDataId + "]").hide();
                    }


                }
            });

            $('.btnConfirm').prop("disabled", false);

        }

        $(".btnConfirm").on("click", function () {

            var cd = $(".stopdt").val();

            var count = $("#ChildEnrolmentCount").val();
            var isSubmit = true;

            console.log("count: " + count);

            for (i = 0; i < count; i++) {
                var cd = $(".stopdt[data-id=" + i + "]").val();
                var cdcheck = $(".cfaradio[data-id=" + i + "]:checked").val();

                var noticeGiven = $(".noticegivenradio[data-id=" + i + "]:checked").val();
                var noticeDt = $(".noticedt[data-id=" + i + "]").val();

                if (cd == "" && cdcheck == 'false') {
                    $("#cfasection .cfadateerror[data-id=" + i + "]").removeClass("d-none");
                    isSubmit = false;
                }
                else {
                    $("#cfasection .cfadateerror[data-id=" + i + "]").addClass("d-none");
                }

                if (cdcheck == 'false' && noticeGiven == 'true' && noticeDt == "") {
                    $("#cfasection .noticedateerror[data-id=" + i + "]").removeClass("d-none");
                    isSubmit = false;
                }
                else {
                    $("#cfasection .noticedateerror[data-id=" + i + "]").addClass("d-none");
                }

            }

            var cfatypeid = $(".cfaapptype").val();
            //if (jsParentHasChilPrograms && cfatypeid == '3') {
            //    console.log(cfatypeid);
            //    var addchildChk = $(".fileuploadradio:checked").val();
            //    if (addchildChk == "") {
            //        console.log("again");
            //        $("#cfasection .addchildconterror").removeClass("d-none");
            //        isSubmit = false;
            //    }
            //}

            if (isSubmit) {
                $("#SubmitWithParentCFA").val('True');

                $("#AcceptEnrolmentForm").submit();
            }
        });


        var appid;
        var applicantid;
        var fileId;

        $(document).on('click', '.btnDel', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var self = $(this);
            appid = self.data('appid');
            applicantid = self.data('applicantid');
            fileId = self.data('fileid');
            $("#fileDeleteModal").modal();
        });

        $(document).on('click', '#btnDeleteUploadYes', function (e) {
            var url = '';
            var self = $(this);

            $("#dvloading").show();

            deleteDocument(fileId, function () { LoadCFASection(jsChildId, jsNBEN, true, $("#ParentId").val()); }, function () { LoadCFASection(jsChildId, jsNBEN, true, $("#ParentId").val()); })

        });

        $(document).on('change', "#_fileUpload input:file", function () {
            var fileName = $(this).val();

            $("#dvloading").show();

            if (!fileName) {
                return;
            }

            var formData = new FormData();
            var d = $(this)[0].files[0];


            var maxfilesize = $(this).data('maxfilesize');

            if (d.size > maxfilesize) {
                $(".maxfilesizeerror").removeClass("d-none");
                $(".loadingBackground").hide();

                return;
            }

            formData.append('File', d);
            formData.append('SourceId', $(this).data('sourceid'));
            formData.append('ApplicantId', $(this).data('applicantid'));
            formData.append('PersonTypeCd', $(this).data('persontypecd'));
            formData.append('DocTypeId', $("#_uploadDocTypes").val());
            formData.append('RequestTypeCd', 8);


            var url = '';
            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/FileUpload/UploadFile/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/FileUpload/UploadFile/';
            }

            $("#_fileUpload .btnUpload").find('i.fa-file-upload').removeClass('fa-file-upload').addClass('fa-spinner fa-spin');
            $("#_fileUpload .btnUpload").prop('disabled', true).attr('disabled', 'disabled');
            $.ajax({
                url: url,
                method: 'POST',
                contentType: false,
                processData: false,
                data: formData,
                success: function (res) {

                    // Hide any errors that exist on the page
                    $(".file-error-alert").addClass("d-none");
                    $("#_fileUpload .btnUpload").prop('disabled', true);
                    $("#dvloading").hide();

                    LoadCFASection(jsChildId, jsNBEN, true, $("#ParentId").val());

                },
                error: function () {

                    // Hide any errors that exist on the page
                    $(".file-error-alert").addClass("d-none");
                    $("#_fileUpload .btnUpload").prop('disabled', true);
                    $("#dvloading").hide();

                    LoadCFASection(jsChildId, jsNBEN, true, $("#ParentId").val());
                }
            });


        });



        // if you don't want the window reloaded on success/fail, pass in onSuccess and onFailure functions
        function deleteDocument(fileUploadId, onSuccess, onFailure) { // default to jsFileUploadId
            // delay the window for a bit, in case this happens really fast


            if (!onSuccess) {
                onSuccess = function () { location.reload(true); }
            }


            if (!onFailure) {
                onFailure = function () { location.reload(true); }
            }

            var formData = new FormData();

            // todo make sure fields are on Enrolment/View
            formData.append('FileUploadId', fileUploadId);
            formData.append('SourceId', $("#_fileUpload").data('sourceid'));
            formData.append('ApplicantId', $("#_fileUpload").data('applicantid'));
            formData.append('ClientUserId', $("#_fileUpload").data('clientuserid'));
            formData.append('RequestTypeCd', $("#_fileUpload").data('requesttypecd'));

            console.log(formData);
            var deleteurl = '';

            if (location.href.indexOf('/en/') > 0) {
                deleteurl = location.href.split('/en/')[0] + '/en/FileUpload/Delete';
            } else {
                deleteurl = location.href.split('/fr/')[0] + '/fr/FileUpload/Delete';
            }

            $.ajax({
                url: deleteurl,
                method: 'POST',
                contentType: false,
                processData: false,
                data: formData,
                success: function (res) {
                    // TODO show error if res.result < 1
                    onSuccess();
                    $(".loadingBackground").hide();
                },
                error: function () {
                    // TODO show error
                    onFailure();
                    $(".loadingBackground").hide();
                }
            });

        }

        //Check if this child has an existing waitlist
        function CheckExistingWaitlist(id, parentId) {
           
            var url = '';

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/child/waitlist/CheckEnrolmentWaitlists/' + id + "?ParentId=" + parentId;
            } else {
                url = location.href.split('/fr/')[0] + '/fr/child/waitlist/CheckEnrolmentWaitlists/' + id + "?ParentId=" + parentId;
            }

            $.ajax({
                url: url,
                method: 'POST',
                contentType: false,
                processData: false,
                error: function () {   },
                success: function (res) {
                    jsExistingwaitlist = res.WaitlistExists;
                    jsChildNotYetBorn = res.ChildNotYetBorn;
                    jsWaitlistId = res.WaitlistId;

                    //Store on the form for the postback and validation
                    $("#ChildNotYetBorn").val(jsChildNotYetBorn);
                    $("#ExistingWaitlist").val(jsExistingwaitlist);
                    $("#WaitlistId").val(jsWaitlistId);

                    //Does a waitlist exist?
                    if (jsChildNotYetBorn) {
                        $("#WaitlistExists").removeClass("d-none");

                        //Is the child not yet born?
                        $("#id_WaitlistFutureSameChild").removeClass("d-none");
                        $("#id_WaitlistSelectChildLabel").addClass("d-none");

                        //Hide the remain on waitlist questions
                        $("#id_WaitlistRemainOn").addClass("d-none");
                    }
                    else {
                        $("#WaitlistExists").addClass("d-none");

                        //Does a waitlist exist?
                        if (jsExistingwaitlist) {
                            $("#WaitlistExists").removeClass("d-none");

                            $("#id_WaitlistFutureSameChild").addClass("d-none");
                            $("#id_WaitlistSelectChildLabel").removeClass("d-none");

                            //Show the remain on waitlist questions
                            $("#id_WaitlistRemainOn").removeClass("d-none");
                        }
                    }
                }
            });
        }
    }
});